var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input-ref",staticClass:"ais-SearchBox-input",attrs:{"type":"search","placeholder":"🔍 Search here..."},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing)return;_vm.query=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }